import {Fraction} from 'opensheetmusicdisplay';

export default class OsmdExtension {
	
	constructor(osmd) {
		this.osmd = osmd;
		this.verticalItemInfos = [];

		this.initialize();
	}

	initialize() {
		this.verticalItemInfos = [];

		const osmd = this.osmd;

		const getMeasureId = (measure) => {
			return measure.parentSourceMeasure.measureListIndex;
		}
		
		if (osmd.graphic.VerticalGraphicalStaffEntryContainers != null) {
			let prevMeasureId = -1;
			
			for (const [vc_i, vc] of osmd.graphic.VerticalGraphicalStaffEntryContainers.entries()) {
				const firstStaffEntry = vc.staffEntries[0];
				const lastStaffEntry = vc.staffEntries[vc.staffEntries.length-1];
				
				// console.log(vc.getFirstNonNullStaffEntry().parentMeasure.measureNumber)
				
				const firstNonNullStaffEntry = vc.getFirstNonNullStaffEntry();
				
				if (firstNonNullStaffEntry) {
					// console.log(firstNonNullStaffEntry.findStaffEntryMinNoteLength())

					let isFirstItemInTheMeasure = false;
					let isLastItemInTheMeasure = false;

					let isFirstItemInTheMusicSystem = false;
					let isLastItemInTheMusicSystem = false;
					
					const measureId = getMeasureId(firstNonNullStaffEntry.parentMeasure);
					const musicSystemId = firstNonNullStaffEntry.parentMeasure.parentMusicSystem.id;
					
					if (measureId > prevMeasureId) {
						isFirstItemInTheMeasure = true;
					}

					if (isFirstItemInTheMeasure) {
						if (measureId == 0) {
							isFirstItemInTheMusicSystem = true;
						} else {
							const prevMeasureOfFirstInstrument = osmd.graphic.measureList[measureId-1][0];
							if (prevMeasureOfFirstInstrument.parentMusicSystem.id < musicSystemId) {
								isFirstItemInTheMusicSystem = true;
							}
						}
					}
					
					if (vc_i == osmd.graphic.VerticalGraphicalStaffEntryContainers.length-1) {
						isLastItemInTheMeasure = true;
					} else {
						const nextVC = osmd.graphic.VerticalGraphicalStaffEntryContainers[vc_i+1];
						
						if (nextVC.getFirstNonNullStaffEntry()) {
							if (getMeasureId(nextVC.getFirstNonNullStaffEntry().parentMeasure) > measureId) {
								isLastItemInTheMeasure = true;
							}
						} else {
							isLastItemInTheMeasure = true;
						}
					}
					
					if (isLastItemInTheMeasure) {
						if (measureId == osmd.graphic.measureList.length-1) {
							isLastItemInTheMusicSystem = true;
						} else {
							const nextMeasureOfFirstInstrument = osmd.graphic.measureList[measureId+1][0];
							if (nextMeasureOfFirstInstrument.parentMusicSystem.id > musicSystemId) {
								isLastItemInTheMusicSystem = true;
							}
						}
					}
					
					///////////////////////////////////////////
					
					const [y1, y2] = this.getMusicSystemYByMeasureId(getMeasureId(firstNonNullStaffEntry.parentMeasure));
					
					this.verticalItemInfos.push(
						{
							x: osmd.graphic.calculateXPositionFromTimestamp(vc.absoluteTimestamp)[0],
							y1: y1,
							y2: y2,
							vc: vc,
							firstNonNullStaffEntry: firstNonNullStaffEntry,
							timestamp: vc.absoluteTimestamp,
							measureId: measureId,
							isFirstItemInTheMeasure: isFirstItemInTheMeasure,
							isLastItemInTheMeasure: isLastItemInTheMeasure,
							isFirstItemInTheMusicSystem: isFirstItemInTheMusicSystem,
							isLastItemInTheMusicSystem: isLastItemInTheMusicSystem,
							isTheLastBeam: false,
							idx: this.verticalItemInfos.length
						}
					)
					
					prevMeasureId = measureId;
				}
			}
		}
	}

	// Find out all the music systems
	// MusicSystem.staffLines may not be available upon the intialization of this instance, so it cannot be found and stored at intialization
	findAllMusicSystems() {
		
		const osmd = this.osmd;

		const musicSystems = [];
		for (const [i, measure] of osmd.graphic.measureList.entries()) {
			const musicSystem = measure[0].parentMusicSystem;
			
			if (musicSystems.length <= musicSystem.id) {
				musicSystems[musicSystems.length] = musicSystem;
			}
		}

		return musicSystems;
	}

	findMusicSystemBreakPosition() { // not including the 0
		const musicSystems = this.findAllMusicSystems();

		const boxPositions = [];

		for (const [i, musicSystem] of musicSystems.entries()) {

			const bb = musicSystem.boundingBox;

			const y1 = this.osmd2ActualPosition(bb.absolutePosition.y + bb.boundingRectangle.y);
			const height = this.osmd2ActualPosition(bb.boundingRectangle.height);
			const y2 = y1 + height;

			boxPositions.push({y1: y1, y2: y2});
		}

		const breakPositions = [];

		for (const [i, boxPosition] of boxPositions.entries()) {
			if (i < boxPositions.length - 1) {
				const nextBoxPosition = boxPositions[i+1];
				
				const breakPosition = (boxPosition.y2 + nextBoxPosition.y1) * 0.5;
				breakPositions.push(breakPosition);
			} else {
				const margin = 10;
				breakPositions.push(Math.min(boxPosition.y2 + margin, this.osmd.container.getBoundingClientRect().height));
			}
		}

		return breakPositions;
	}

	getMusicSystemActualPositionY(musicSystem) {
		let [y1, y2] = this.getMusicSystemY(musicSystem);
		y1 = this.osmd2ActualPosition(y1);
		y2 = this.osmd2ActualPosition(y2);
		return [y1, y2];
	}

	getMusicSystemY(musicSystem) { // return y positions in osmd space
		const topStaffLine = musicSystem.StaffLines[0];
		const y1 = musicSystem.PositionAndShape.AbsolutePosition.y + topStaffLine.PositionAndShape.RelativePosition.y;

		const bottomStaffLine = musicSystem.StaffLines[musicSystem.StaffLines.length - 1];
		const y2 = y1 + bottomStaffLine.PositionAndShape.RelativePosition.y + bottomStaffLine.StaffHeight;

		return [y1, y2];
	}
	
	getMusicSystemYByMeasureId(measureId) { // return y positions in osmd space
		const osmd = this.osmd;

		const measure = osmd.graphic.measureList[measureId];
		const musicSystem = measure[0].parentMusicSystem;

		return this.getMusicSystemY(musicSystem);
	}
	
	osmd2ActualPosition(pos) {
		const osmd = this.osmd;
		return pos * 10 * osmd.Zoom + osmd.container.offsetLeft;
	}
	
	actual2OsmdPosition(pos) {
		const osmd = this.osmd;
		return (pos - osmd.container.offsetLeft) / osmd.Zoom / 10;
	}

	getVerticalItemInfoByTimestamp(timestamp) {
		const osmd = this.osmd;
		
		for (const [_, verticalItemInfo] of this.verticalItemInfos.entries()) {
			if (verticalItemInfo.timestamp.Equals(timestamp)) {
				return verticalItemInfo;
			}
		}

		// Return a vertical item info for the last beam
		const lastVerticalItemInfo = this.verticalItemInfos[this.verticalItemInfos.length-1];
		if (timestamp.RealValue > lastVerticalItemInfo.timestamp.RealValue) {
			const lastMeasureInMusicSystem = osmd.graphic.measureList[lastVerticalItemInfo.measureId];

			const musicSystemX2 = 
				lastMeasureInMusicSystem[0].boundingBox.absolutePosition.x +
				lastMeasureInMusicSystem[0].boundingBox.boundingRectangle.x + 
				lastMeasureInMusicSystem[0].boundingBox.boundingRectangle.width
			;

			const dummyVerticalItemInfo = Object.assign({}, lastVerticalItemInfo);
			dummyVerticalItemInfo.x = musicSystemX2;
			dummyVerticalItemInfo.isTheLastBeam = true;
			// modifiedVerticalItemInfo.measureId += 1;
			dummyVerticalItemInfo.timestamp = Fraction.plus(dummyVerticalItemInfo.timestamp, dummyVerticalItemInfo.firstNonNullStaffEntry.findStaffEntryMinNoteLength());

			// console.log("A", this.osmd2ActualPosition(musicSystemX2));
			
			// console.log(dummyVerticalItemInfo);
			return dummyVerticalItemInfo;
		}

		return null;
	}
	
	getClosestVerticalItemInfo(x, y, y1Tolerance=0, y2Tolerance=0) { // x,y in osmd space
		const osmd = this.osmd;
	
		let closestXDistance = Number.MAX_VALUE;
		let closestVerticalItemInfo = null;
		for (const [_, verticalItemInfo] of this.verticalItemInfos.entries()) {
			if (y >= verticalItemInfo.y1 - y1Tolerance && y < verticalItemInfo.y2 + y2Tolerance) {
				if (Math.abs(x - verticalItemInfo.x) < closestXDistance) {
					closestXDistance = Math.abs(x - verticalItemInfo.x);
					closestVerticalItemInfo = verticalItemInfo;
				}
			}
		}
		
		if (closestVerticalItemInfo) {
			if (closestVerticalItemInfo.isLastItemInTheMusicSystem) { // select the last beam in the music system
				const lastMeasureInMusicSystem = osmd.graphic.measureList[closestVerticalItemInfo.measureId];
				
				const musicSystemX2 = 
					lastMeasureInMusicSystem[0].boundingBox.absolutePosition.x +
					lastMeasureInMusicSystem[0].boundingBox.boundingRectangle.x + 
					lastMeasureInMusicSystem[0].boundingBox.boundingRectangle.width
				;
				
				if (x >= musicSystemX2) {
					const modifiedVerticalItemInfo = Object.assign({}, closestVerticalItemInfo);
					modifiedVerticalItemInfo.x = musicSystemX2;
					modifiedVerticalItemInfo.isTheLastBeam = true;
					// modifiedVerticalItemInfo.measureId += 1;
					modifiedVerticalItemInfo.timestamp = Fraction.plus(modifiedVerticalItemInfo.timestamp, modifiedVerticalItemInfo.firstNonNullStaffEntry.findStaffEntryMinNoteLength());

					// console.log("A", this.osmd2ActualPosition(musicSystemX2));
					
					// console.log(dummyVerticalItemInfo);
					return modifiedVerticalItemInfo;
				}
			}
		
			return closestVerticalItemInfo;
		} else {
			return null;
		}
	}
};